import { motion } from "framer-motion";
import { Star, MapPin, Award, Calendar } from "lucide-react";

const stats = [
  { icon: Star, value: "5,0 / 5", label: "141 avis Google", color: "#A8843F" },
  { icon: Award, value: "Partenaire", label: "officiel SoundYoga", color: "#C86B52" },
  { icon: Calendar, value: "Depuis 2023", label: "1ᵉʳ centre yoga Compiègne", color: "#8C9A86" },
  { icon: MapPin, value: "Compiègne", label: "Boutique physique", color: "#4A3320" },
];

export default function SocialProof() {
  return (
    <section
      className="relative py-10 md:py-14 px-6 md:px-12 lg:px-20 bg-cream border-y border-ink/10"
      data-testid="social-proof"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
        {stats.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="flex items-center gap-4"
              data-testid={`proof-${i}`}
            >
              <div
                className="w-11 h-11 md:w-12 md:h-12 rounded-full flex items-center justify-center shrink-0"
                style={{ backgroundColor: `${s.color}18` }}
              >
                <Icon size={18} style={{ color: s.color }} />
              </div>
              <div>
                <div className="font-serif text-xl md:text-2xl text-ink leading-tight">
                  {s.value}
                </div>
                <div className="text-[10px] md:text-xs uppercase tracking-[0.15em] text-ink/55">
                  {s.label}
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
